export type ContactTypeMapping = {
  label: string;
  relationships: string[];
};

export function uniqueSorted(values: string[]): string[] {
  return Array.from(
    new Set(values.map((v) => String(v).trim()).filter(Boolean))
  ).sort((a, b) =>
    a.localeCompare(b, undefined, { sensitivity: 'base', numeric: true })
  );
}

export function buildRelToLabel(
  mappings: ReadonlyArray<ContactTypeMapping>
): Map<string, string> {
  const map = new Map<string, string>();
  for (const m of mappings) {
    for (const r of m.relationships || []) {
      const key = String(r);
      if (!map.has(key)) map.set(key, m.label);
    }
  }
  return map;
}

export function labelToRelationships(
  labels: readonly string[] | undefined,
  mappings: ReadonlyArray<ContactTypeMapping>
): string[] {
  const index = new Map<string, Set<string>>();
  for (const m of mappings) {
    index.set(m.label, new Set((m.relationships || []).map((r) => String(r))));
  }
  const out = new Set<string>();
  for (const l of labels ?? []) {
    const set = index.get(l);
    if (set && set.size) set.forEach((r) => out.add(r));
    else if (l) out.add(l);
  }
  return Array.from(out);
}
